import works from './works'
import tourWorks from './tourWorks'

const content = {
  logo: {
    image: require('./images/MCA_white_400px.png'),
    url: 'https://www.mca.com.au/',
  },


  menu: [
    {
      text: 'Home',
      url: '/',
    },
    {
      text: 'The Artist',
      url: '/the-artist',
    },
    {
      text: 'The Exhibition',
      url: '/the-exhibition',
    },
    
    {
      text: 'Exhibition Guide',
      url: '/tour',
    },
     
    {
      text: 'Exhibition Map',
      url: '/tour/map',
    },

    
  /*  {
      text: 'Your Visit',
      url: '/yourvisit-page',
    }, */
   /* {
      text: 'Tickets',
      url: '/tickets',
    }, */
    
    {
      text: 'Auslan',
      url: '/tour/auslan',
    },
    
  ],


  feature: {
    video: '224281358',
       /*
    backgroundVideo: '222783999',
*/
    images: [
      require('./images/works/MCA - Pipilotti Rist - Gnade Donau Gnade2.jpg'),
      require('./images/works/onepage_slide_pipilotti_2.jpg'),
      require('./images/works/carousel_4th-FLOOR_VIEW-6_SCALE-A.jpg'),
    ],

    primaryTitle: 'Pipilotti Rist',
    secondaryTitle: 'Sip my Ocean',
    description: 'This exhibition has now closed. Thank you to all that visited!',
    bookingLink: 'https://www.mca.com.au/pipilotti-rist/tour',
    moreLink: '/#About',
    start: '1 Nov',
    end: '18 Feb',
  },


  introduction: require('./markdown/Introduction.md'),

  works: works,

  carousel: [
    {
      image: require('./images/works/one_page_slide_Pixel-Forest-2016.jpg'),
      body: require('./markdown/carousel/carousel_quote_4.md'),
    },
    /*{
      image: require('./images/works/one-page-slide-Selfless-In-The-Bath-of-Lava.jpg'),
      body: require('./markdown/carousel/when-i-close-my-eyes_2.md'),
    },*/
    {
      image: require('./images/works/one_page_slide_Mercy-Garden-Retour-Skin.jpg'),
      body: require('./markdown/carousel/carousel_quote_3.md'),
    },
    {
      image: require('./images/works/Carousel_Gnade-Donau-Gnade.jpg'),
      body: require('./markdown/carousel/when-i-close-my-eyes.md'),
    },
    /*{
      video: '222617465',
      image: require('./images/works/onepage_slide_pipilotti_3.jpg'),
      body: require('./markdown/carousel/carousel_quote_4.md'),
    },*/
  ],


  /* NEWS */
 news: [
   /*

    {
      title: 'Kids & Families',
      url: '/news/kidsandfamilies',
      image: require('./images/pages/01_FNT_Pipilotti-Rist_Sip-My-Ocean.jpg'),
      excerpt: require('./markdown/news/kidsandfamilies-excerpt.md'),
      sections: [
        {
          title: 'Kids & Families',
          body: require('./markdown/news/kidsandfamilies.md'),
        }
      ]
    },

    {
      title: 'Events & Tours',
      url: '/news/eventsandtours',
      image: require('./images/news/events_tours_2.jpg'),
      excerpt: require('./markdown/news/eventsandtours-excerpt.md'),
      sections: [
        {
          body: require('./markdown/news/eventsandtours.md'),
        }
      ]
    },

    {
      title: 'Dining & Drinks',
      url: '/news/dining',
      image: require('./images/news/Winter-menu-2017_2.jpg'),
      excerpt: require('./markdown/news/dining-excerpt.md'),
      sections: [
        {
          body: require('./markdown/news/dining.md'),
        }
      ]
    },

    {
      title: 'Travel & Accommodation',
      url: '/news/travel',
      image: require('./images/pages/QT-Bondi---Icebergs-Ocean-Pool_1920.jpg'),
      excerpt: require('./markdown/news/travel-excerpt.md'),
      sections: [
        {
          body: require('./markdown/news/travel.md'),
        }
      ]
    },

   {
      title: 'The Sydney International Art Series ',
      excerpt: require('./markdown/news/sias-excerpt.md'),
      sections: [
        {
          body: require('./markdown/news/sias.md'),
        }
      ]
    },*/
  ],

  pages: [
    /*page*/
    {
      title: 'Example Page',
      url: '/example-page',
      video: '224281358',
      image: require('./images/works/onepage_slide_pipilotti_3.jpg'),
      sections: [
        {
          body: require('./markdown/pages/tickets_1.md'),
        },
        {
          body: require('./markdown/pages/tickets_2.md'),
        },
        {
          button: {
            text: 'Buy Art Pass Now',
            link: 'https://tickets.mca.com.au/?Event=76300',
          }
        },
        {
          body: require('./markdown/pages/tickets_3.md'),
        },
        {
          button: {
            text: 'Buy a mca membership',
            link: 'https://app.etapestry.com/bbphosted/nl_mca/MembershipForm.html',
          }
        },
        {
          body: require('./markdown/pages/tickets_4.md'),
        },



        {
          title: 'Carousel Title',
          carousel: [
            {
              image: require('./images/works/onepage_slide_pipilotti_1.jpg'),
              body: require('./markdown/carousel/when-i-close-my-eyes.md'),
            },
            {
              image: require('./images/works/onepage_slide_pipilotti_2.jpg'),
              body: require('./markdown/carousel/when-i-close-my-eyes_2.md'),
            },
            {
              image: require('./images/works/onepage_slide_pipilotti_3.jpg'),
              body: require('./markdown/carousel/carousel_quote_3.md'),
            },
            {
              image: require('./images/works/work_1_768_624_3.jpg'),
              body: require('./markdown/carousel/carousel_quote_4.md'),
            },
            {
              video: '222617465',
              image: require('./images/works/onepage_slide_pipilotti_3.jpg'),
              body: require('./markdown/carousel/carousel_quote_4.md'),
            },
          ],
        },
        {
          title: 'Posts Title',
          posts: [
            {
              title: 'artist',
              url: '/the-artist',
              image: require('./images/news/Kids_families_2.jpg'),
              excerpt: require('./markdown/news/kidsandfamilies-excerpt.md'),
            },

            {
              title: 'Travel & Accommodation',
              url: '/news/travel',
              image: require('./images/news/QT_Sydney_Room_1566x486.jpg'),
              excerpt: require('./markdown/news/travel-excerpt.md'),
            },
          ]
        },
      ],
    },


    /* this section refers to individual pages */

    /*page*/
    {
      title: 'Example Page 2',
      url: '/example-page-2',
      image: require('./images/pages/example-page-2.png'),
      sections: [
        {
          title: 'Example Page 2',
          body: require('./markdown/pages/example-page-2.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'Example Page 3',
      url: '/example-page-3',
      image: require('./images/pages/example-page_3.jpg'),
      sections: [
        {
          title: 'Example Page 3',
          body: require('./markdown/pages/example-page-3.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'The Artist',
      url: '/the-artist',
      image: require('./images/pages/pipi_portrait.jpg'),
      sections: [
        {
          title: 'The Artist',
          body: require('./markdown/pages/the-artist.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'The Exhibition',
      url: '/the-exhibition',
      video: '224281358',
      image: require('./images/works/Exhibition_video_1.jpg'),


      sections: [
        {
        title: 'The Exhibition',
          body: require('./markdown/pages/the-exhibition.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'Kids & Families',
      url: '/kidsandfamilies-page',
      image: require('./images/pages/kids_fam_newdec17hi.jpg'),
      sections: [
         {
        title: 'kids & families',
          body: require('./markdown/pages/kidsandfamilies-page1.md'),
        },
               {
          body: require('./markdown/pages/kidsandfamilies-page2.md'),
        },

      ]
    },

    /*page*/


    {
      title: 'Events & Tours',
      url: '/Eventsandtours_page',
      image: require('./images/pages/guide_tours_page.jpg'),
      sections: [
        {
        title: 'Events & Tours',
          body: require('./markdown/pages/Eventsandtours_page.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'Dining & Drinks',
      url: '/Dining_page',
      image: require('./images/news/Winter-menu-2017_2.jpg'),
      sections: [
        {
        title: 'Dining & Drinks',
          body: require('./markdown/pages/Dining_page.md'),
        }
      ]
    },

    /*page*/
    {
      title: 'Travel & Accommodation',
      url: '/Travel_and_Accommodation_page',
      image: require('./images/news/QT_Sydney_Room_1566x486.jpg'),
      sections: [
        {
        title: 'Travel & Accommodation',
          body: require('./markdown/pages/packages_page.md'),
        }
      ]
    },
    {
      title: 'Tickets',
      url: '/tickets',
      image: require('./images/works/tickets_Gnade-Donau-Gnade.jpg'),
      sections: [
        {
          title: 'Tickets',
          body: require('./markdown/pages/tickets_1.md'),
        },
                {
          body: require('./markdown/pages/tickets_2.md'),
        },
        {
          button: {
            text: 'Buy Art Pass Now',
            link: 'https://tickets.mca.com.au/?Event=76300',
          }
        },
        {
          body: require('./markdown/pages/tickets_3.md'),
        },
        {
          button: {
            text: 'Buy an mca membership',
            link: 'https://app.etapestry.com/bbphosted/nl_mca/MembershipForm.html',
          }
        },
        {
          body: require('./markdown/pages/tickets_4.md'),
        },
      ]
    }, 


    /*page*/
    
    /* Laughter page disabled
    {
      title: 'Laughter Sessions',
      url: '/laughter-workshops',
      image: '',
      sections: [
        {
        title: 'Laughter Sessions',
          body: require('./markdown/pages/laughter-workshops.md'),
        }
      ]
    },
    */

    {
      title: 'Work-Shop in Colour Fields',
      url: '/work-shop',
      image: '',
      sections: [
        {
        title: 'Work-Shop in Colour Fields',
          body: require('./markdown/pages/work-shop.md'),
        }
      ]
    },
    
    
    
    

    /* this section refers to the your visit tiles on the your visit page */

    {
      title: 'Your Visit Page',
      url: '/yourvisit-page',

      sections: [
        {
          title: 'Your Visit',
          body: require('./markdown/pages/yourvisit.md'),
        },

        {
          posts: [
            {
              title: 'Kids & Families',
              url: '/kidsandfamilies-page',
              image: require('./images/pages/kids_fam_newdec17hi.jpg'),
              excerpt: require('./markdown/news/kidsandfamilies-excerpt.md'),
            /*  sections: [
                {
                  title: 'Kids & Families',
                  body: require('./markdown/pages/kidsandfamilies-page.md'),
                }
              ]*/
            },

            {
              title: 'Events & Tours',
              url: '/Eventsandtours_page',
              image: require('./images/news/guide_869x278.jpg'),
              excerpt: require('./markdown/news/eventsandtours-excerpt.md'),
            },

            {
              title: 'Dining & Drinks',
              url: '/Dining_page',
              image: require('./images/news/010_Young_Henrys-MCA_Cafe_Terrace_869x278.jpg'),
              excerpt: require('./markdown/news/dining-excerpt.md'),
            },

            {
              title: 'Travel & Accommodation',
              url: '/Travel_and_Accommodation_page',
              image: require('./images/news/QT_Sydney_Room_869x278.jpg'),
              excerpt: require('./markdown/news/travel-excerpt.md'),
            },
          ]
        },
      ],
    },

  ],

  /* end page*/


  footer: {
    links: [
      {
       title: 'Part of the',
        images: [
          {
            image: require('./images/footer/SIAS_stacked_rev_web.png'),
            url: 'http://www.artpass.com.au/',
          },
        ],
      },

      {
        title: 'Strategic Sponsor',
        images: [
          {
            image: require('./images/footer/nsw_gov2.png'),
            url: '',
          },
        ],
      },

      {
        title: 'Presenting Partner',
        images: [
          {
            image: require('./images/footer/citi.png'),
          },
        ],
      },

       {
        title: 'Major Exhibition Patrons',
        images: [
          {
            image: require('./images/footer/simon.png'),
          },
        ],
      },


      {
        title: 'Supporter',
        images: [
          {
            image: require('./images/footer/prohelvetia_large.png'),
          },
        ],
      },
      {
        title: 'Media Partner',
        images: [
          {
            image: require('./images/footer/smh_hi_res_80percent.png'),
          },
        ],
      },
      {
        title: 'Government Partners',
        images: [
        {
            image: require('./images/footer/create_nsw2.png'),
          },
          {
            image: require('./images/footer/ozco_larger.png'),
          },
        ],
      },
    ],
    copyright: require('./markdown/footer/footer_text.md'),
  },


  tour: {
    items: tourWorks
  }
}


export default content



// WEBPACK FOOTER //
// ./src/Rist/content/index.js